<div class="image-modal-container">
  <!-- Header -->
  <div class="modal-header">
    <div class="image-info">
      <h3 *ngIf="currentImage" class="image-title">{{ currentImage.original_filename }}</h3>
      <span class="image-counter">{{ getImageCounter() }}</span>
    </div>
    <button 
      mat-icon-button 
      (click)="onClose()"
      class="close-button"
      aria-label="Schließen">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Image Container -->
  <div class="image-content">
    <!-- Previous Button -->
    <button 
      *ngIf="hasPrevious()"
      mat-icon-button 
      (click)="previousImage()"
      class="nav-button nav-button-left"
      aria-label="Vorheriges Bild">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <!-- Image -->
    <div class="image-wrapper" *ngIf="currentImage">
      <img 
        [src]="getImageUrl(currentImage)"
        [alt]="currentImage.original_filename"
        class="modal-image"
        (error)="onImageError($event)">
      
      <!-- Loading Spinner -->
      <div class="loading-spinner" *ngIf="!currentImage">
        <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
      </div>
    </div>

    <!-- Next Button -->
    <button 
      *ngIf="hasNext()"
      mat-icon-button 
      (click)="nextImage()"
      class="nav-button nav-button-right"
      aria-label="Nächstes Bild">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

  <!-- Footer with Image Details -->
  <div class="modal-footer" *ngIf="currentImage">
    <div class="image-details">
      <div class="detail-item">
        <span class="detail-label">Dateiname:</span>
        <span class="detail-value">{{ currentImage.original_filename }}</span>
      </div>
      <div class="detail-item" *ngIf="currentImage.uploadDate">
        <span class="detail-label">Hochgeladen:</span>
        <span class="detail-value">{{ currentImage.uploadDate | date:'dd.MM.yyyy HH:mm' }}</span>
      </div>
      <div class="detail-item" *ngIf="currentImage.user_name">
        <span class="detail-label">Von:</span>
        <span class="detail-value">{{ currentImage.user_name }}</span>
      </div>
    </div>
  </div>
</div>

